import axios from "axios";

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
});

export const apiSafraLink = axios.create({
  baseURL: process.env.REACT_APP_SAFRALINK_API_HOST,
});
